/**
 * Narrow-layout breakpoint (ZW-276), shared by the editor shell, the splash
 * page, and the `data-zw-narrow` root attribute. A surface switches to the
 * mobile layout when its measured width is at most `NARROW_LAYOUT_MAX_PX`,
 * and back to the desktop layout only once it is at least
 * `WIDE_LAYOUT_MIN_PX`. The gap keeps a window dragged across the breakpoint
 * from flipping back and forth.
 */
export const NARROW_LAYOUT_MAX_PX = 767;
export const WIDE_LAYOUT_MIN_PX = 784;

/** Next `narrowLayout` value for a measured width (with hysteresis). */
export function narrowLayoutForWidth(current: boolean, width: number): boolean {
  if (width <= 0) return current;
  if (width <= NARROW_LAYOUT_MAX_PX) return true;
  if (width >= WIDE_LAYOUT_MIN_PX) return false;
  return current;
}
